import { ApiResponse, PaginatedResponse } from "../types/common";
import {
  Event,
  CreateEventRequest,
  UpdateEventRequest,
  EventFilter,
} from "../types/landing";
import api from "./api";

// Event CRUD Operations
export const eventService = {
  getAllEvents: async (
    filters: EventFilter = {}
  ): Promise<PaginatedResponse<Event>> => {
    try {
      const params = new URLSearchParams();

      if (filters.page) params.append("page", filters.page.toString());
      if (filters.limit) params.append("limit", filters.limit.toString());
      if (filters.search) params.append("search", filters.search);
      if (filters.status) params.append("status", filters.status);
      if (filters.category) params.append("category", filters.category);
      if (filters.startDate) params.append("startDate", filters.startDate);
      if (filters.endDate) params.append("endDate", filters.endDate);

      const response = await api.get(
        `/landing/events/admin?${params.toString()}`
      );

      const data = response as any;
      return {
        success: data.success,
        data: data.data || [],
        pagination: {
          currentPage: data.currentPage || 1,
          totalPages: data.totalPages || 1,
          totalItems: data.total || 0,
          hasNext: (data.currentPage || 1) < (data.totalPages || 1),
          hasPrev: (data.currentPage || 1) > 1,
        },
      };
    } catch (error) {
      console.error("Error fetching events:", error);
      throw error;
    }
  },

  getEventById: async (id: string): Promise<ApiResponse<Event>> => {
    try {
      const response = await api.get(`/landing/events/${id}`);
      return response as any;
    } catch (error) {
      console.error("Error fetching event by ID:", error);
      throw error;
    }
  },

  createEvent: async (
    eventData: CreateEventRequest
  ): Promise<ApiResponse<Event>> => {
    try {
      const response = await api.post("/landing/events", eventData);
      return response as any;
    } catch (error) {
      console.error("Error creating event:", error);
      throw error;
    }
  },

  updateEvent: async (
    id: string,
    eventData: UpdateEventRequest
  ): Promise<ApiResponse<Event>> => {
    try {
      const response = await api.put(`/landing/events/${id}`, eventData);
      return response as any;
    } catch (error) {
      console.error("Error updating event:", error);
      throw error;
    }
  },

  deleteEvent: async (id: string): Promise<ApiResponse<null>> => {
    try {
      const response = await api.delete(`/landing/events/${id}`);
      return response as any;
    } catch (error) {
      console.error("Error deleting event:", error);
      throw error;
    }
  },

  publishEvent: async (id: string): Promise<ApiResponse<Event>> => {
    try {
      const response = await api.patch(`/landing/events/${id}/publish`);
      return response as any;
    } catch (error) {
      console.error("Error publishing event:", error);
      throw error;
    }
  },

  unpublishEvent: async (id: string): Promise<ApiResponse<Event>> => {
    try {
      const response = await api.patch(`/landing/events/${id}/unpublish`);
      return response as any;
    } catch (error) {
      console.error("Error unpublishing event:", error);
      throw error;
    }
  },

  cancelEvent: async (id: string): Promise<ApiResponse<Event>> => {
    try {
      const response = await api.patch(`/landing/events/${id}/cancel`);
      return response as any;
    } catch (error) {
      console.error("Error cancelling event:", error);
      throw error;
    }
  },
};
